import image1 from "../assets/chem-br.png";
import image2 from "../assets/chem-ad.png";
import image3 from "../assets/chem-di.png";
import image4 from "../assets/chem-tri.png";
import image5 from "../assets/chem-chl.png";
import image6 from "../assets/chem-az.png";
import fenbendazole from "../assets/43210-67-9.png";
import ncarbethoxy from "../assets/29976-53-2.png";
import tbutylchlorobutyrophenone from "../assets/43076-61-5.png";
import benzylhydroxyindazole from "../assets/2215-63-6.png";
import benzhydrol from "../assets/91-01-0.png";
import glicalazide from "../assets/21187-98-4.png";
import albendazole from "../assets/54965-21-8.png";
import ebastine from "../assets/90729-43-4.png";
import adapalene from "../assets/106685-40-9.png";
import amiloridehydrochloride from "../assets/17440-83-4.png";
import riboflavin from "../assets/83-88-5.png";
import riboflavinsodiumphosphate from "../assets/130-40-5.png";
import benzydaminehydrochloride from "../assets/132-69-4.png";
import oxfendazole from "../assets/53716-50-0.png";
import nikethamide from "../assets/59-26-7.png";
import nicotinamide from "../assets/98-92-0.png";

const products = [
    {
        name: "Methyl 6-Bromo-Naphthalene-2-Carboxylate",
        img: image1,
        bg: "pink-bg",
        description: [
            "CAS No: 33626-98-1",
            "Molecular Formula: C12H9BrO2",
            "Molecular Weight: 265.1",
            "Targeted API: Adapalene"
        ]
    },
    {
        name: "2-(1-Adamantyl)-4-bromoanisole",
        img: image2,
        bg: "green-bg",
        description: [
            "CAS No: 104224-63-7",
            "Molecular Formula: C17H21BrO",
            "Molecular Weight: 321.26",
            "Targeted API: Adapalene"
        ]
    },
    {
        name: "2,6-Diamino-4-chloropyrimidine",
        img: image3,
        bg: "blue-bg",
        description: [
            "CAS No: 156-83-2",
            "Molecular Formula: C4H5N4Cl",
            "Molecular Weight: 144.56",
            "Targeted API: Minoxidil"
        ]
    },
    {
        name: "2,4,6-Trichloro pyrimidine",
        img: image4,
        bg: "pink-bg",
        description: [
            "CAS No: 3764-01-0",
            "Molecular Formula: C4HCl3N2",
            "Molecular Weight: 183.42",
            "Targeted API: Minoxidil"
        ]
    },
    {
        name: "Methyl 3,5-diamino-6-chloropyrazine-2-carboxylate",
        img: image5,
        bg: "green-bg",
        description: [
            "CAS No: 1458-01-1",
            "Molecular Formula: C6H7ClN4O2",
            "Molecular Weight: 202.60",
            "Targeted API: Amiloride"
        ]
    },
    {
        name: "3-Amino-3-Azabicyclo (3,3,0)Octane Hydrochloride",
        img: image6,
        bg: "blue-bg",
        description: [
            "CAS No: 58108-05-7",
            "Molecular Formula: C7H14N2HCl",
            "Molecular Weight: 162.66",
            "Targeted API: Gilclazide"
        ]
    },
    {
        name: "Fenbendazole",
        img: fenbendazole,
        bg: "pink-bg",
        description: [
            "CAS No: 43210-67-9",
            "Therapeutic Use: Antiparasitic"
        ]
    },
    {
        name: "N-Carbethoxy-4-piperidone",
        img: ncarbethoxy,
        bg: "pink-bg",
        description: [
            "CAS No: 29976-53-2",
            "Targeted API: Ebastine, Bepotastine"
        ]
    },
    {
        name: "4'-tert-butyl-4-chlorobutyrophenone",
        img: tbutylchlorobutyrophenone,
        bg: "pink-bg",
        description: [
            "CAS No: 43076-61-5",
            "Targeted API: Ebastine"
        ]
    },
    {
        name: "1-Benzyl-3-hydroxy-1H-indazole",
        img: benzylhydroxyindazole,
        bg: "pink-bg",
        description: [
            "CAS No: 2215-63-6",
            "Targeted API: Benzydamine hydrochloride"
        ]
    },
    {
        name: "Benzhydrol",
        img: benzhydrol,
        bg: "pink-bg",
        description: [
            "CAS No: 91-01-0",
            "Targeted API: Ebastine"
        ]
    },
    {
        name: "Glicalazide",
        img: glicalazide,
        bg: "blue-bg",
        description: [
            "CAS No: 21187-98-4",
            "Therapeutic Use: Anti-diabetic"
        ]
    },
    {
        name: "Albendazole",
        img: albendazole,
        bg: "pink-bg",
        description: [
            "CAS No: 54965-21-8",
            "Therapeutic Use: Antihelmintic and Antiprotozoal"
        ]
    },
    {
        name: "Ebastine",
        img: ebastine,
        bg: "pink-bg",
        description: [
            "CAS No: 90729-43-4",
            "Therapeutic Use: Antihistamine"
        ]
    },
    {
        name: "Adapalene",
        img: adapalene,
        bg: "pink-bg",
        description: [
            "CAS No: 106685-40-9",
            "Therapeutic Use: Acne vulgaris"
        ]
    },
    {
        name: "Amiloride Hydrochloride",
        img: amiloridehydrochloride,
        bg: "green-bg",
        description: [
            "CAS No: 17440-83-4",
            "Therapeutic Use: Antihypertensive, potassium-sparing diuretic"
        ]
    },
    {
        name: "Fenbendazole",
        img: fenbendazole,
        bg: "pink-bg",
        description: [
            "CAS No: 43210-67-9",
            "Therapeutic Use: Antiparasitic"
        ]
    },
    {
        name: "Riboflavin",
        img: riboflavin,
        bg: "pink-bg",
        description: [
            "CAS No: 83-88-5",
            "Therapeutic Use: Vitamin B2"
        ]
    },
    {
        name: "Riboflavin Sodium Phosphate",
        img: riboflavinsodiumphosphate,
        bg: "pink-bg",
        description: [
            "CAS No: 130-40-5",
            "Therapeutic Use: Vitamin B2"
        ]
    },
    {
        name: "Benzydamine Hydrochloride",
        img: benzydaminehydrochloride,
        bg: "pink-bg",
        description: [
            "CAS No: 132-69-4",
            "Therapeutic Use: A topical, non-steroidal anti-inflammatory drug"
        ]
    },
    {
        name: "Oxfendazole",
        img: oxfendazole,
        bg: "pink-bg",
        description: [
            "CAS No: 53716-50-0",
            "Therapeutic Use: Antihelminthic"
        ]
    },
    {
        name: "Nikethamide",
        img: nikethamide,
        bg: "pink-bg",
        description: [
            "CAS No: 59-26-7",
            "Therapeutic Use: Stimulants"
        ]
    },
    {
        name: "Nicotinamide",
        img: nicotinamide,
        bg: "pink-bg",
        description: [
            "CAS No: 98-92-0",
            "Therapeutic Use: Vitamin B3"
        ]
    }
];

export default products;
